import React from "react";

import styles from "./Maps.module.scss";
import PreviousPage from "../../../partials/PreviousPage/PreviousPage";
import { SELLER } from "../../../../config/legal";

const Maps: React.FC = () => {
  return (
    <section className={styles.maps}>
      <div className="container">
        <PreviousPage currentPage="Контакты" title="Контакты компании Тканополис" />
        <div className={styles.info}>
          <p className={styles.text}>{SELLER.name}</p>
          <p className={styles.text}>ИНН {SELLER.inn}</p>
          <p className={styles.text}>
            ОГРНИП {SELLER.ogrnip}, выдан {SELLER.ogrnipIssued}
          </p>
          <p className={styles.text}>Юридический адрес: {SELLER.address}</p>
          <p className={styles.text}>Банк: {SELLER.bank}</p>
          <p className={styles.text}>Расчётный счёт: {SELLER.account}</p>
          <p className={styles.text}>БИК: {SELLER.bik}</p>
          <p className={styles.text}>Корреспондентский счёт: {SELLER.corrAccount}</p>
          <p className={styles.text}>Адрес банка: {SELLER.bankAddress}</p>
          <p className={styles.text}>Сайт: {SELLER.site}</p>
        </div>
      </div>
    </section>
  );
};

export default Maps;
